// import apiRequest from 'shared/services/api';

import { ACTION_TYPE } from './actionTypes';

const { ID_PASSPORT } = ACTION_TYPE;

const updateIdPassportData = (name, value) => ({
  type: ID_PASSPORT.UPDATE_ID_PASSPORT_DATA,
  payload: { name, value },
});

const fetchIdPassportData = obj => ({
  type: ID_PASSPORT.FETCH_ID_PASSPORT,
  payload: {
    fullName: obj.fullName,
    civilId: obj.civilId === null ? '' : obj.civilId,
    passportId: obj.passportId === null ? '' : obj.passportId,
    selfie: obj.selfie,
    civilIdFront: obj.civilIdFront,
    civilIdBack: obj.civilIdBack,
    passport: obj.passport,
    tobeEmailed: obj.tobeEmailed === true ? 'tobeEmailed' : '',
    isWithCivilId: obj.isWithCivilId,
  },
});

const idPassportAction = {
  updateIdPassportData,
  fetchIdPassportData,
};

export default idPassportAction;
